import React from "react";
import Loader from "react-loader-spinner";
import Modal from '../components/Modal'
import HttpServices from "../utils/Http.services";
import { imageAddress, translate } from "../utils/useful";


class SearchUsersModal extends React.Component {
    state = {
        data: [],
        selecteds: {},
        currentTab: "users",
        data: [],
        filteredData: [],
    }

    componentDidMount() {
        this.initData()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            this.initData()
        }
    }

    showModal = () => {
        this.initData()
        this.modal.showModal()
    }

    hideModal = () => {
        this.setState({ selecteds: {}, data: [] })
        this.modal.hideModal()

    }


    initData = () => {
        this.fetchData()
        this.setState({ selecteds: {} }, () => {
            if (Array.isArray(this.props.data)) {
                let selecteds = this.state.selecteds
                this.props.data.forEach(element => {
                    selecteds[element.thing?._id] = { _id: element.thing?._id, removed: false, init: true }
                });
            }

        })
    }

    search = (query) => {
        const { data } = this.state;
        const filteredData = data.filter((item) => {
            let newTitle = item.name.replace('ي', 'ی')
            return newTitle.toLowerCase().includes(query.toLowerCase())
        }
        );
        this.setState({ filteredData });
    };

    fetchData = () => {

        this.setState({ isLoadingData: true })
        let address
        if (this.props.currentTab == 'users') {
            address = 'employeeGetAll'
        }
        else {
            address = 'getAllRoles'
        }
        // console.log('find user ', address)
        HttpServices.request(address, {}, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoadingData: false })

            if (fetchError) {
                return
            }
            // console.log('get all users', fetchResult)
            this.setState({ rawData: fetchResult.info, data: fetchResult.info, filteredData: fetchResult.info })

        })
    }



    onDone = () => {
        this.setState({ isLoadingPost: true })
        let selecteds = this.state.selecteds
        let final = []
        console.log(selecteds)

        this.props.onDone(selecteds, 'users', () => {
            this.setState({ isLoadingPost: false })
            this.modal.hideModal()
        })
    }

    changeCurrentTab = (key) => {
        if (this.props.currentTab != key) {
            let address
            if (key == 'users') {
                address = 'getAllUser'
            }
            else {
                address = 'getAllRoles'
            }
            // this.setState({ currentTab: key })
            this.props.setData('currentTab', key)

            HttpServices.request(address, {}, (fetchResult, fetchError, fetchStatus) => {
                this.setState({ isLoadingData: false })

                if (fetchError) {
                    return
                }
                console.log('fetchResultss', fetchResult)
                this.setState({ rawData: fetchResult.info, data: fetchResult.info, filteredData: fetchResult.info })

            })
        }
    }


    changeSelect = (prop) => {
        console.log('changeSelect', prop)

        let selecteds = this.state.selecteds
        if (!this.props.single) {

            if (!selecteds[prop._id] || selecteds[prop._id].removed) {
                selecteds[prop._id] = { _id: prop._id, name: prop.name, image: prop.image, type: prop.type, userName: prop.userName, role: this.props.currentTab }
            } else {
                delete selecteds[prop._id]
            }
        }
        else {
            if (!selecteds[prop._id] || selecteds[prop._id].removed) {
                selecteds = { [prop._id]: { _id: prop._id, name: prop.name, image: prop.image, type: prop.type, userName: prop.userName, role: this.props.currentTab } }
            } else {
                delete selecteds[prop._id]
            }
        }

        console.log(selecteds)

        this.setState({ selecteds })
    }

    renderHeaderSubmit = () => {
        if (this.state.isLoadingPost) {
            return (
                <div className="flexcc px-2">
                    <Loader
                        type="Oval"
                        color="#fff"
                        height={20}
                        width={20}
                    />
                </div>
            )
        }
        return (
            <button onClick={() => this.onDone()} style={{ backgroundColor: '#ffffffde', borderRadius: 30 }}>
                <span className="text-normal px-3 py-1">{translate('Submit')}</span>
            </button>
        )
    }

    renderUserList = () => (
        <div className="w-100 text-start">
            {this.state.filteredData.map((prop, index) => (
                <div key={index} onClick={() => this.changeSelect(prop)} className="flexcb backHover pb-1 pt-1 cursor-pointer" style={{ borderBottom: '0px solid #f2f4f6', backgroundColor: (this.state.selecteds[prop._id] && this.state.selecteds[prop._id].removed != true) ? '#007aff20' : 'transparent' }}>
                    <div className='flexcc mrd-3'>
                        <div>
                            <img src={imageAddress(prop.image, 'profile', 'thumb')} width="40px" style={{ borderRadius: 50, height: 40, objectFit: 'cover' }} alt="" />
                        </div>
                        <div>
                            <p className="text-small mx-2">{prop.name}</p>
                            {prop.userName ? (
                                <p className="text-smaller mx-2" style={{ color: '#789' }}>@{prop.userName}</p>
                            ) : (
                                <p className="text-smaller mx-2" style={{ color: '#789' }}>{translate('Virtual User')}</p>
                            )}
                        </div>
                    </div>
                </div>
            ))}

            {this.state.filteredData?.length === 0 && (
                <div className="text-center mt-5">
                    <img src="/images/target.svg" width="50px" alt="" />
                    <p className="text-center text-small text-bold">{translate('foundNothing')}</p>
                    <p className="text-center text-smaller">{translate('Change your search options')}</p>
                </div>
            )}
        </div>
    )

    renderGroupList = () => (
        <div className="w-100 text-start">
            {this.state.filteredData.map((prop, index) => (
                <div key={index} onClick={() => this.changeSelect(prop)} className="flexcb backHover pb-1 pt-1 cursor-pointer" style={{ borderBottom: '0px solid #f2f4f6', backgroundColor: (this.state.selecteds[prop._id] && this.state.selecteds[prop._id].removed != true) ? '#007aff20' : 'transparent' }}>
                    <div className='flexcc mrd-3'>
                        <div>
                            <img src={imageAddress(prop.image, 'profile', 'thumb')} width="40px" style={{ borderRadius: 50, height: 40, objectFit: 'cover' }} alt="" />
                        </div>
                        <div>
                            <p className="text-small mx-2">{prop.name}</p>
                        </div>
                    </div>
                </div>
            ))}

            {this.state.filteredData?.length === 0 && (
                <div className="text-center mt-5">
                    <img src="/images/target.svg" width="50px" alt="" />
                    <p className="text-center text-small text-bold">{translate('foundNothing')}</p>
                    <p className="text-center text-smaller">{translate('Change your search options')}</p>
                </div>
            )}
        </div>
    )

    render() {
        return (

            <Modal ref={el => this.modal = el} maxWidth={400}>
                <div className="w-100 h-100">
                    <div
                        className="w-100"
                        style={{
                            maxHeight: '75vh',
                            backgroundColor: '#fff',
                            borderRadius: 9,
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden',
                        }}
                    >
                        <div
                            className="w-100"
                            style={{
                                zIndex: 1,
                                padding: '7px 20px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexShrink: 0,
                                borderBottom: '0px #eee solid',
                                backgroundColor: '#2162ba',
                                background: 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))',
                                backdropFilter: 'blur(10px) saturate(180%)',
                                WebkitBackdropFilter: 'blur(10px) saturate(180%)',
                                borderRadius: '8px 8px 0px 0px',
                            }}
                        >
                            <p className="white py-2">{translate('Add')}</p>
                            <div className="flexc">
                                {this.renderHeaderSubmit()}
                            </div>
                        </div>

                        <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                            <div className="w-100 mt-1 mb-1 pl-3 pr-3 pt-2 pb-1" style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                <input onChange={(e) => this.search(e.target.value)} placeholder={translate("Search")} className="w-100" style={{ height: 40, fontSize: 15, padding: '5px 15px', background: '#f2f6f8', borderRadius: 30, border: '1px solid #eee' }} />
                            </div>

                            <div className="p-4 pt-2">
                                {this.props.currentTab == 'users' ? this.renderUserList() : this.renderGroupList()}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );

    }
}


export default SearchUsersModal;
